export const firebaseDev = {
  apiKey: 'AIzaSyDQGfLq_VlaWa9zZQHkO7ckqciDwMqgB08',
  authDomain: 'instacares-sandbox.firebaseapp.com',
  databaseURL: 'https://instacares-sandbox.firebaseio.com/',
  projectId: 'instacares-sandbox', 
  storageBucket: 'instacares-sandbox.appspot.com',
  messagingSenderId: '770086705258',
  appId: '1:770086705258:web:21bc4ebaed5ceb56c29213'
}

export const firebaseProd = {
  apiKey: 'AIzaSyA4hQ4LFyLxGIl1DYSKZmSCES75GQiyxA8',
  authDomain: 'instacares-production.firebaseapp.com',
  projectId: 'instacares-production',
  storageBucket: 'instacares-production.appspot.com',
  messagingSenderId: '326904528742',
  appId: '1:326904528742:web:7b36b3f786a61f2f6a92a7',
  measurementId: 'G-2CMDEYVRF0'
}
